import * as yup from "yup";
export const HMInventorySchema = yup.object().shape({
  item: yup.string().required("Required"),
  hsn: yup.string(),
  unit: yup.string(),
  weight_unit: yup.string(),
  weight: yup.string(),
  productSpecification: yup.string(),
  brandName: yup.string(),
  size: yup.string().required("Required"),
  count: yup.number(),
  shortName: yup.string(),
  hydroponicType: yup.string(),
  cost: yup.number(),
  image: yup.string(),
  inStock: yup.number(),
  thresholdLimit: yup.number(),
  specifications: yup.string(),
  specificationsNew: yup.array(),
  needTransportation: yup.boolean(),
  iteminList: yup.boolean(),
  needPackaging: yup.boolean(),
  isFragile: yup.boolean(),
  costFromVendor: yup.string(),
  location: yup.string(),
  rackId: yup.string(),
  fabricationChargesMarkup: yup.string(),
  handlingCharges: yup.string(),
  optionalWarrantyCovergePerUnit: yup.string(),
  hydroponicTypeNew: yup
    .array()
    .of(yup.string().required("Type is required")) // each element must be a string
    .min(1, "You must select at least one hydroponic type")
    .required("Hydroponic type is required"),

  fabricationProcess: yup.array(),
  materialType: yup.string(),
  gst: yup.string(),
  proUnit: yup.string().required("Required"),
});
